export var getHttpCommonHeaders = function (instance) {
    return {
        Authorization: instance,
    };
};
//# sourceMappingURL=http.js.map